import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { Button, FlexColumn, FlexRow, Modal } from 'design-system';
import { CloseIcon } from 'design-system/components/Icons';

export default function VideoPlaybackModal({ isOpen, onClose, video }) {
  const intl = useIntl();
  const [playBackVideo, setPlaybackVideo] = useState(null);
  const objectUrlRef = useRef(null);

  useEffect(() => {
    if (objectUrlRef.current) {
      URL.revokeObjectURL(objectUrlRef.current);
      objectUrlRef.current = null;
    }
    if (!isOpen) {
      setPlaybackVideo(null);
      return undefined;
    }
    if (!video) {
      setPlaybackVideo(null);
      return undefined;
    }
    const tag = video && typeof video === 'object' ? Object.prototype.toString.call(video) : '';
    if (tag === '[object File]' || tag === '[object Blob]') {
      const objectUrl = URL.createObjectURL(video);
      objectUrlRef.current = objectUrl;
      setPlaybackVideo(objectUrl);
      return () => {
        if (objectUrlRef.current) {
          URL.revokeObjectURL(objectUrlRef.current);
          objectUrlRef.current = null;
        }
      };
    }
    setPlaybackVideo(typeof video === 'string' && video.trim() !== '' ? video : null);
    return undefined;
  }, [isOpen, video]);

  const handleOnCloseClick = () => {
    if (objectUrlRef.current) {
      URL.revokeObjectURL(objectUrlRef.current);
      objectUrlRef.current = null;
    }
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      type="success"
      showIcon={false}
      showClose={false}
      onDismiss={handleOnCloseClick}
      className="cc-video-playback-modal"
    >
      <FlexRow align="center" justify="end" fullWidth className="cc-video-playback-modal__toolbar">
        <Button
          type="button"
          variant="link"
          size="sm"
          className="cc-video-playback-modal__close-btn"
          aria-label={intl.formatMessage({ id: 'close' })}
          icon={
            <CloseIcon size={20} strokeWidth={1.5} aria-hidden className="cc-video-playback-modal__close-icon" />
          }
          onClick={handleOnCloseClick}
        />
      </FlexRow>
      <Modal.Body className="cc-video-playback-modal__body">
        <FlexColumn align="stretch" fullWidth className="cc-video-playback-modal__video-wrap">
          {playBackVideo ? (
            <video
              className="cc-video-playback-modal__video"
              controls
              playsInline
              autoPlay
              muted
              src={playBackVideo}
              aria-label={intl.formatMessage({ id: 'video-playback' })}
            />
          ) : null}
        </FlexColumn>
      </Modal.Body>
    </Modal>
  );
}
